// Third party imports
import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  serviceTypes: [],
};

// Slice
const serviceTypesSlice = createSlice({
  name: "serviceTypes",
  initialState,
  reducers: {
    setServiceTypes: (state, action) => {
      state.serviceTypes = action.payload;
    },
    clearServiceTypes: (state) => {
      state.serviceTypes = [];
    },
  },
});

// Actions
export const { setServiceTypes, clearServiceTypes } = serviceTypesSlice.actions;

// Reducer
export default serviceTypesSlice.reducer;
